const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");
const fetchNavItem = require("./fetchNavItem");

module.exports = function fetchUserBookmarks(user, authContext) {
	const [
		{ isAuthenticated },
		{ dispatch, logout, checkAuth, isLoggedIn },
		[userData, setUserData],
	] = authContext;
	return new Promise(async (resolve, reject) => {
		let response = await fetchAuthenticatedContent({
			endpoint: `user/user/${user.id}?include=field_bookmarks`,
			dispatch,
		});

		if (!response.error) {
			const { included = [] } = response;

			const bookmarkReponses = await Promise.all(
				included.map(async (item) => {
					let nav = await fetchNavItem(item);
					return {
						...item.attributes,
						id: item.id,
						type: item.type,
						summary: item.attributes.field_summary,
						isHtmlSummary: true,
						slug: nav ? nav.slug : null,
					};
				})
			);
			resolve(bookmarkReponses);
		}

		resolve(response);
	});
};
